__turbopack_context__.v({
  "blue": "Hirforrasok-module__zycL8W__blue",
  "box": "Hirforrasok-module__zycL8W__box",
  "listbox": "Hirforrasok-module__zycL8W__listbox",
  "main": "Hirforrasok-module__zycL8W__main",
});
